export const TOOL_PPT_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.87204 6.55484L6.06566 6.90043C5.97811 6.93794 5.97811 7.06206 6.06566 7.09957L6.87204 7.44517C7.17886 7.57666 7.42334 7.82114 7.55484 8.12796L7.90043 8.93434C7.93795 9.02189 8.06206 9.02189 8.09958 8.93434L8.44517 8.12796C8.57666 7.82114 8.82114 7.57666 9.12797 7.44517L9.93434 7.09957C10.0219 7.06206 10.0219 6.93794 9.93434 6.90043L9.12797 6.55483C8.82114 6.42334 8.57666 6.17886 8.44517 5.87204L8.09958 5.06566C8.06206 4.97811 7.93795 4.97811 7.90043 5.06566L7.55484 5.87204C7.42334 6.17886 7.17886 6.42334 6.87204 6.55484Z"
      fill="#0077FA"
    />
    <path
      d="M2 3H14"
      stroke="#1C1F23"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M5 13L7 11"
      stroke="#1C1F23"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M11 13L9 11"
      stroke="#1C1F23"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M13 3V9C13 10.1046 12.1046 11 11 11H5C3.89543 11 3 10.1046 3 9V3"
      stroke="#1C1F23"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
)

export const TOOL_TRANS_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3807_53824)">
      <path
        d="M3.33331 5.3335L7.33331 9.3335M2.66665 9.3335L6.66665 5.3335L7.99998 3.3335M1.33331 3.3335H9.33331M4.66665 1.3335H5.33331M14.6666 14.6668L11.3333 8.00016L7.99998 14.6668M9.33331 12.0002H13.3333"
        stroke="#1C1F23"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.872 3.55484L11.0657 3.90043C10.9781 3.93794 10.9781 4.06206 11.0657 4.09957L11.872 4.44517C12.1789 4.57666 12.4233 4.82114 12.5548 5.12796L12.9004 5.93434C12.9379 6.02189 13.0621 6.02189 13.0996 5.93434L13.4452 5.12796C13.5767 4.82114 13.8211 4.57666 14.128 4.44517L14.9343 4.09957C15.0219 4.06206 15.0219 3.93794 14.9343 3.90043L14.128 3.55483C13.8211 3.42334 13.5767 3.17886 13.4452 2.87204L13.0996 2.06566C13.0621 1.97811 12.9379 1.97811 12.9004 2.06566L12.5548 2.87204C12.4233 3.17886 12.1789 3.42334 11.872 3.55484Z"
        fill="#0077FA"
      />
    </g>
    <defs>
      <clipPath id="clip0_3807_53824">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const TOOL_SEARCH_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 4H2M3.66667 8H2M6.66667 12H2M14 13.6667L12.7333 12.4M13.3333 11C13.3333 12.1046 12.4379 13 11.3333 13C10.2288 13 9.33333 12.1046 9.33333 11C9.33333 9.89543 10.2288 9 11.3333 9C12.4379 9 13.3333 9.89543 13.3333 11Z"
      stroke="#1C1F23"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.87204 7.55484L5.06566 7.90043C4.97811 7.93794 4.97811 8.06206 5.06566 8.09957L5.87204 8.44517C6.17886 8.57666 6.42334 8.82114 6.55484 9.12796L6.90043 9.93434C6.93795 10.0219 7.06206 10.0219 7.09958 9.93434L7.44517 9.12796C7.57666 8.82114 7.82114 8.57666 8.12797 8.44517L8.93434 8.09957C9.02189 8.06206 9.02189 7.93794 8.93434 7.90043L8.12797 7.55483C7.82114 7.42334 7.57666 7.17886 7.44517 6.87204L7.09958 6.06566C7.06206 5.97811 6.93795 5.97811 6.90043 6.06566L6.55484 6.87204C6.42334 7.17886 6.17886 7.42334 5.87204 7.55484Z"
      fill="#0077FA"
    />
  </svg>
)

export const TOOL_PROMPT_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 7.99984L12 5.33317M4.00001 5.33317L1.33334 7.99984L4.00001 10.6665M9.66668 2.6665L6.33334 13.3332"
      stroke="#1C1F23"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.872 10.5548L10.0657 10.9004C9.97811 10.9379 9.97811 11.0621 10.0657 11.0996L10.872 11.4452C11.1789 11.5767 11.4233 11.8211 11.5548 12.128L11.9004 12.9343C11.9379 13.0219 12.0621 13.0219 12.0996 12.9343L12.4452 12.128C12.5767 11.8211 12.8211 11.5767 13.128 11.4452L13.9343 11.0996C14.0219 11.0621 14.0219 10.9379 13.9343 10.9004L13.128 10.5548C12.8211 10.4233 12.5767 10.1789 12.4452 9.87204L12.0996 9.06566C12.0621 8.97811 11.9379 8.97811 11.9004 9.06566L11.5548 9.87204C11.4233 10.1789 11.1789 10.4233 10.872 10.5548Z"
      fill="#0077FA"
    />
  </svg>
)
